import { useEffect, useRef } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import tippy from 'tippy.js';

import { isMobile, constructPopupContent } from '../Utilities/Helpers';

import 'simplebar-react/dist/simplebar.min.css';
import 'react-spring-bottom-sheet/dist/style.css';
import '../Styles/Sidebar.css';

export default function Sidebar(props) {
	const { show, data, onToggle, setSelectedData, setSidebarWidth, language } = props;

	const ref = useRef(null);
	const mobile = isMobile();

	const onClose = () => {
		onToggle(false);
		setSelectedData(null);
	}

	const generateContent = (selectedData) => {
		if (!selectedData) return;

		const content = constructPopupContent({
			language,
			data: selectedData,
			toString: false
		});

		return content;
	}

	// init tippy.js
	useEffect(() => {
		[...document.querySelectorAll('.nitrate-health-icon-wrapper')].forEach(el => { tippy(el) });
	}, []);

	// Detect Sidebar width
	useEffect(() => {
		const handleResize = () => { setSidebarWidth(ref.current ? ref.current.offsetWidth : 0) }
		handleResize();
		window.addEventListener('resize', handleResize)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref.current]);

	return ((mobile) ?
		<BottomSheet
			onDismiss={onClose}
			blocking={false}
			open={show}
			defaultSnap={({ maxHeight }) => maxHeight / 2}
			snapPoints={({ maxHeight }) => [
				maxHeight - maxHeight / 10,
				maxHeight / 4,
				maxHeight * 0.6,
			]}
		>
			{generateContent(data)}
		</BottomSheet>
	:
		<div ref={ref} className={show ? 'sidebar-wrapper show': 'sidebar-wrapper'}>
			<div className='sidebar'>
				<div className='content-wrapper'>
					{generateContent(data)}
				</div>
			</div>
		</div>
	)
}
